// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/global_alert_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { WorkflowAutoCreationRuleNotice } from "./workflow_auto_creation_rule_model_pb";
import { file_bffuser_v1_workflow_auto_creation_rule_model } from "./workflow_auto_creation_rule_model_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/global_alert_model.proto.
 */
export const file_bffuser_v1_global_alert_model: GenFile = /*@__PURE__*/
  fileDesc("CiNiZmZ1c2VyL3YxL2dsb2JhbF9hbGVydF9tb2RlbC5wcm90bxIKYmZmdXNlci52MSItChRPY2N0b0NyZWRlbnRpYWxBbGVydBIVCg1idXNpbmVzc19jb2RlGAEgASgJInIKI1dvcmtmbG93QXV0b0NyZWF0aW9uUnVsZU5vdGljZUVudHJ5Eg8KB3J1bGVfaWQYASABKAkSOgoGbm90aWNlGAIgASgOMiouYmZmdXNlci52MS5Xb3JrZmxvd0F1dG9DcmVhdGlvblJ1bGVOb3RpY2VCQFo+Z2l0aHViLmNvbS9lbmVjaGFpbi9lYmFsYW5jZS9nby9nZW4vcHJvdG8vYmZmdXNlci92MTtiZmZ1c2VydjFiBnByb3RvMw", [file_bffuser_v1_workflow_auto_creation_rule_model]);

/**
 * OcctoCredentialAlert is one OCCTO 事業者コード under the 認証情報不備 warning
 * (spec plan-common.md AC-PLC-053). Mirrors internalapi.v1.OcctoCredentialAlert.
 *
 * @generated from message bffuser.v1.OcctoCredentialAlert
 */
export type OcctoCredentialAlert = Message<"bffuser.v1.OcctoCredentialAlert"> & {
  /**
   * OCCTO 事業者コード (4 digits).
   *
   * @generated from field: string business_code = 1;
   */
  businessCode: string;
};

/**
 * Describes the message bffuser.v1.OcctoCredentialAlert.
 * Use `create(OcctoCredentialAlertSchema)` to create a new message.
 */
export const OcctoCredentialAlertSchema: GenMessage<OcctoCredentialAlert> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_global_alert_model, 0);

/**
 * WorkflowAutoCreationRuleNoticeEntry is one 定期 自動起票ルール that has a
 * notice (spec AC-WFT-050 / shared-components.md AC-SC-044).
 *
 * @generated from message bffuser.v1.WorkflowAutoCreationRuleNoticeEntry
 */
export type WorkflowAutoCreationRuleNoticeEntry = Message<"bffuser.v1.WorkflowAutoCreationRuleNoticeEntry"> & {
  /**
   * @generated from field: string rule_id = 1;
   */
  ruleId: string;

  /**
   * Never UNSPECIFIED.
   *
   * @generated from field: bffuser.v1.WorkflowAutoCreationRuleNotice notice = 2;
   */
  notice: WorkflowAutoCreationRuleNotice;
};

/**
 * Describes the message bffuser.v1.WorkflowAutoCreationRuleNoticeEntry.
 * Use `create(WorkflowAutoCreationRuleNoticeEntrySchema)` to create a new message.
 */
export const WorkflowAutoCreationRuleNoticeEntrySchema: GenMessage<WorkflowAutoCreationRuleNoticeEntry> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_global_alert_model, 1);

